import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingClientDocument,
  useClientSaveSigningQuestionnaireStepMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useClientSaveSigningQuestionnaire = () => {
  const [handle, { loading, error: apolloError }] =
    useClientSaveSigningQuestionnaireStepMutation({
      refetchQueries: [OnboardingClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  return {
    loading,
    error,
    signingQuestionnaire: useCallback(
      async (clientId: string, otpCode: string) => {
        const res = await handle({
          variables: { id: clientId, otpCode },
        });

        return !!res.data?.clientSaveSigningQuestionnaireStep;
      },
      [handle]
    ),
  };
};
